
import { useMemo } from "react";
import { MapLocation } from "@/types/location";

export const useLocationProcessing = (
  originalLocations: MapLocation[]
) => {
  // Synchronous useMemo so locations always reflect the current originalLocations
  // in the same render cycle — eliminates the one-render stale-state lag that
  // caused locations to disappear after Maintenance → Operational toggles.
  const locations = useMemo(
    () => originalLocations.map(loc => ({ ...loc, isImported: false as const })) as MapLocation[],
    [originalLocations]
  );

  return { locations };
};

